import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard {
  private auth = inject(AuthService);
  private router = inject(Router);

  isFirst = true;

  canActivate(
    route: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.auth.token$.pipe(
      map(
        (token) =>
          !!token ||
          this.router.createUrlTree([route.data['redirectTo']], {
            queryParams: state?.url ? { returnUrl: state.url } : {},
          })
      )
    );
  }
}
